import React, { PureComponent } from 'react';
import { groupBy } from 'lodash';
import { array, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import PixelList from './PixelsList';
import PixelListItem from './PixelListItem';

class PixelsList extends PureComponent {
  static propTypes = {
    groups: array.isRequired,
    showGroupName: bool,
  };

  static defaultProps = {
    groups: [],
    showGroupName: false,
  };

  makePixelGroupsList = () => groupBy(this.props.groups, 'group_name');

  renderPixelGroupsList = () => {
    const groups = this.makePixelGroupsList();
    const items = [];
    const { showGroupName, isCdn, coins, id, withLink, theme } = this.props;

    for (let groupName in groups) {
      if (!groups.hasOwnProperty(groupName)) {
        continue;
      }

      const pixels = groups[groupName];

      if (theme === 4 && pixels.length === 1) {
        pixels.forEach(pixel => {
          // items.push([
          //   <PixelListItem
          //     theme={theme}
          //     key={pixel.id}
          //     pixel={pixel}
          //     isCdn={isCdn}
          //     coins={coins}
          //   />,
          //   <li>
          //     <Link to={`/tickets/create?theme=pixelRequest&offer=${id}`}>
          //       <FormattedMessage
          //         id="offer.buttons.pixels-request"
          //         defaultMessage="Did you find a higher payout?"
          //       />
          //     </Link>
          //   </li>,
          // ]);
          items.push(
            theme === 4 ? (
              [
                <PixelListItem
                  theme={theme}
                  key={pixel.id}
                  pixel={pixel}
                  isCdn={isCdn}
                  coins={coins}
                />,
                <li>
                  <Link to={`/tickets/create?theme=pixelRequest&offer=${id}`}>
                    <FormattedMessage
                      id="offer.buttons.pixels-request"
                      defaultMessage="Did you find a higher payout?"
                    />
                  </Link>
                </li>,
              ]
            ) : (
              <PixelListItem
                theme={theme}
                key={pixel.id}
                pixel={pixel}
                isCdn={isCdn}
                coins={coins}
              />
            ),
          );
        });
      } else {
        items.push(
          <li key={pixels[0].id}>
            {showGroupName && theme !== 4 && (
              <span className="pixel-group-name">
                <span className="pixels-group-title">
                  <FormattedMessage id="offer.pixels.group_title" defaultMessage="Target" />:
                </span>{' '}
                {groupName !== 'null' && <span className="pixels-group-value">{groupName}</span>}
              </span>
            )}
            <PixelList id={id} withLink={withLink} pixels={pixels} isCdn={isCdn} coins={coins} />
          </li>,
        );
      }
    }

    return items;
  };

  render() {
    return <ul className="pixel-groups-list">{this.renderPixelGroupsList()}</ul>;
  }
}

export default PixelsList;
